export default {
    owner: 'Владелец услуги',

    tabs: {
        details: 'Детали',
        availability: 'Доступность',
    },
}
